import Cookies from 'js-cookie';

export default class SubscriptionSuccess {

	constructor() {
		this.isTemplate = document.body.classList.contains('page-template-page-template-subscription-success');
		this.redirectURLCookie = 'gigs_mailchimp_form_redirect';
	}

	init() {
		if (this.isTemplate) {
			const redirectURL = Cookies.get(this.redirectURLCookie);
			Cookies.remove(this.redirectURLCookie);
			window.location.replace(redirectURL || '/');
		}
	}

	destroy() {

	}
}
